import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ActivatedRoute } from '@angular/router';

//import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service';
//import { SubsidiaryPlacementEntryComponent } from '../subsidiary-placement-entry/subsidiary-placement-entry.component';
import { environment } from 'src/environments/environment';
import { CourseService } from 'src/app/services/http/business/course/course.service';


@Component({
  selector: 'app-subsidiary-classes',
  templateUrl: './subsidiary-classes.component.html',
  styleUrls: ['./subsidiary-classes.component.css']
})
export class SubsidiaryClassesComponent implements OnInit {
  filter: any;
  customer: any;
  dataSource = new MatTableDataSource();
  baseUrl = environment.BaaseUrl;

  displayedColumns: string[] = [
    this.translate.get("label.level"),
    "branch",
    this.translate.get("label.teacherName"),
    "date",
    this.translate.get("label.pattern"),
    this.translate.get("label.discount"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.room"),
    this.translate.get("label.status")
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams: any;
  contract: any;

  constructor(
    private route: ActivatedRoute,
    //private dialog: MatDialog,
    public translate: TranslateService,
    // private snackBar: SnackBarService,
    //private subsidiaryStudentService: SubsidiaryStudentService,
    private courseService: CourseService,
    private subsidiaryContractService: SubsidiaryContractService,

  ) {
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
    });
    // this.getContractById();
    this.refresh();
  }

  // getLevelName(LevelPrerequisiteHolding: any) {
  //   return LevelPrerequisiteHolding.filter(function (e) {
  //     return e.RelationTypeId == 3
  //   })[0].PackageName + ' - ' + LevelPrerequisiteHolding.filter(function (e) {
  //     return e.RelationTypeId == 3
  //   })[0].LevelName
  // }
  getContractById() {
    this.subsidiaryContractService.getContract(this.filter).subscribe(
      res => {
        this.contract = res.DataList[0];
      }
    );
  }

  refresh() {
    this.courseService.AghList(this.filter.ContractId, null).subscribe(
      res => {
        // this.paginator.pageSize = 10;
        // this.paginator.length = res.Total;
        // this.pageIndex = 0;
        // this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  // paginatorEvent(event) {
  //   this.subsidiaryStudentService.getStudentsInContract(this.filter, event.pageIndex + 1, event.pageSize)
  //     .subscribe(res => {
  //       this.pageSize = event.pageSize;
  //       this.paginator.length = res.Total;
  //       this.pageIndex = event.pageIndex + 1;
  //       this.dataSource = new MatTableDataSource(res.DataList);
  //     });
  // }

  // placement(params: any) {

  //   this.dialog.open(SubsidiaryPlacementEntryComponent, {
  //     width: "350px",
  //     data: params,
  //     disableClose: false
  //   })
  //     .afterClosed()
  //     .subscribe(() => {
  //       this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
  //     });
  // }

}
